import { render, staticRenderFns } from "./NewFullGradingView.vue?vue&type=template&id=5c055df2&scoped=true"
import script from "./NewFullGradingView.vue?vue&type=script&lang=js"
export * from "./NewFullGradingView.vue?vue&type=script&lang=js"
import style0 from "./NewFullGradingView.vue?vue&type=style&index=0&id=5c055df2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c055df2",
  null
  
)

export default component.exports